import { PAYMENT_METHOD_IDS } from 'Components/PaymentMethodModal/constants/paymentOptions'

export function getYappyPayments(payments) {
  if (!payments?.length) return []
  return payments.filter(
    p =>
      p.PaymentType?.toLowerCase() === PAYMENT_METHOD_IDS.YAPPY.toLowerCase() ||
      // Fallback for records missing PaymentType: match only the
      // payment method's own PaymentName label (same convention as
      // getPaymentType in OrdenDeVenta/utils/paymentTypesValidation.js),
      // not Description, which can hold free-text notes unrelated to the
      // payment method itself.
      p.PaymentName?.toLowerCase()?.includes('yappy')
  )
}
